export function useGameFunctions() {
  const { $api } = useNuxtApp()

  function markGameAsCalled(game: ManageGame) {
    $api('/tournaments/games/mark-called', {
      method: 'POST',
      body: {
        game_id: game.id,
      },
    })
  }

  return {
    markGameAsCalled,
  }
}
